import { render, staticRenderFns } from "./RequestDetailResponse.vue?vue&type=template&id=71787b14"
import script from "./RequestDetailResponse.vue?vue&type=script&lang=js"
export * from "./RequestDetailResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports